import { Inject, Injectable } from '@angular/core';
import { OclSmsService } from '../../../ocl/services/ocl-sms-service/ocl-sms.service';
import { OpsModuleConfigService } from '../ops-module-config/ops-module-config.service';
import { SmsSenderService } from 'src/app/common/services/sms/sms-sender.service';

@Injectable({
  providedIn: 'root',
})
export class OpsSmsService extends OclSmsService {
  constructor(
    protected readonly smsSenderService: SmsSenderService,
    @Inject('CONSTANTS') protected CONSTANTS,
    @Inject('$translate') protected $translate,
    protected moduleConfig: OpsModuleConfigService,
  ) {
    super(smsSenderService, CONSTANTS, $translate, moduleConfig);

    this.$translate.onReady(() => {
      this.SENDER_SUFFIX = this.$translate.instant('SMS.OPS.SENDER_SUFFIX') || 'OPS';
    });
  }
}
